<template>
  <div>
    <form>
      <b-card
        style="
          border: solid 1px #f5a623;
          padding: 0px;
          width: 100%;
          margin-left: 0rem !important;
          margin-right: 1rem !important;
          background-color: #ebedef !important;
        "
      >
        <div class="row">
          <div class="col-12">
            <div class="form-group">
               <label>kilometrage</label> 
              <input
                aria-label="label"
                type="text"
                class="form-control personalise"
                placeholder="Mat"
                v-model="all.nb_klm"
              />
            </div>
          </div>
        </div>
      
        <CButton
          @click.prevent="create"
          type="submit"
          size="sm"
          color="info"
          style="border-radius: 24px; margin-left: 22px; height: 36px"
        >
          Modifier</CButton
        >
      </b-card>
    </form>
  </div>
</template>


<style lang="scss" scoped>
.md-card {
  width: 98%;
  margin: 4px;
  margin-left: 11px;
  display: inline-block;
  vertical-align: top;
}
</style>

<script>
import Vue from "vue";

import { apiDomain } from "../../config";
import axios from "axios";
export default {
  components: {},
  name: "register",
  data() {
    return {
   
      all: [],
 
    };
  },
  created() {
    this.get_service(this.$route.params.id);
    
  },
  mounted() {},
  computed: {
 

  },
  methods: {
  
    get_service(id) {
      fetch(`${apiDomain}/api/show_Kilometrage/${this.$route.params.id}`)
        .then((res) => res.json())
        .then((res) => {
          this.all = res[0];
        })
        .catch((err) => console.log(err));
    },
    create(e) {
      let formData = new FormData();
      formData.append("nb_klm", this.all.nb_klm);
      

      axios
        .post(
          `${apiDomain}/api/update_kilometrage/${this.$route.params.id}`,
          formData
        )

        .then((res) => {
          this.$noty.success("Kilometrage Modifier avec Succès ! ");

          this.$router.go("-1");

          // this.fetchsearch();
        })
        .catch((error) => {
          if (error.response && error.response.status == 400) {
            this.validationErrors = error.response.data;
          }
        });
    },
    
  }
};
</script>

<style lang="scss" >
.glow-on-hover {
  width: 90px;
  height: 76px;
  border: none;
  outline: none;
  color: #fff;
  background: #24b2dc;
  cursor: pointer;
  position: relative;
  z-index: 0;
  border-radius: 10px;
}

.glow-on-hover:before {
  content: "";
  /*   background: #20b3b3;
  color: #fff; */
  background: linear-gradient(
    45deg,
    #ff0000,
    #ff7300,
    #fffb00,
    #48ff00,
    #00ffd5,
    #002bff,
    #7a00ff,
    #ff00c8,
    #ff0000
  );
  position: absolute;
  top: -2px;
  left: -2px;
  background-size: 400%;
  z-index: -1;
  filter: blur(5px);
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  animation: glowing 20s linear infinite;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  border-radius: 10px;
}

.glow-on-hover:active {
  color: #000;
}

.glow-on-hover:active:after {
  background: transparent;
}

.glow-on-hover:hover:before {
  opacity: 1;
}

.glow-on-hover:after {
  z-index: -1;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: #de8e15;
  left: 0;
  top: 0;
  border-radius: 10px;
}

@keyframes glowing {
  0% {
    background-position: 0 0;
  }
  50% {
    background-position: 400% 0;
  }
  100% {
    background-position: 0 0;
  }
}

/* ***** */
.custom-input {
  text-align: center;
  color: #fff;
  font-weight: bold;
  font-size: 1.4em;
  background-color: #341677;
}
</style>